{
    "ChangeLang_Title": "Taal wijzigen",
    "ChangeLang_Subtitle": "Selecteer de taal waarin u de inhoud van de webpagina's wilt bekijken binnen uw huidige websessie op deze computer.",
    "ChangeLang_Field_Label": "Taal",
    "ChangeLang_Remember_Label": "Onthoud mijn selectie",
    "ChangeLang_Buttons_Apply": "Toepassen",
    "ChangeLang_Buttons_Cancel": "Annuleren",
    "NAME": "ChangeLangLanguage"
}